import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-excel.svg'
import _imports_1 from '@/assets/images/icon-delete.svg'


const _withScopeId = n => (_pushScopeId("data-v-079b6d80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-8 w-full h-auto" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-4"
}
const _hoisted_3 = { class: "flex flex-row gap-4 lg:gap-0" }
const _hoisted_4 = { class: "flex justify-center" }
const _hoisted_5 = { class: "flex flex-col justify-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[16px]" }, "N° de Acciones A", -1))
const _hoisted_7 = { class: "text-[28px] font-bold text-[#9BB441] mr-5" }
const _hoisted_8 = { class: "text-[16px]" }
const _hoisted_9 = { class: "flex justify-center px-4" }
const _hoisted_10 = { class: "flex flex-col justify-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[16px]" }, "N° de Acciones B", -1))
const _hoisted_12 = { class: "text-[28px] font-bold text-[#9BB441] mr-5" }
const _hoisted_13 = { class: "text-[16px]" }
const _hoisted_14 = { class: "flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4" }
const _hoisted_15 = { class: "flex flex-col md:flex-row gap-4 s:items-center" }
const _hoisted_16 = { class: "relative flex flex-row items-center gap-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "whitespace-nowrap" }, "Fecha de inicio", -1))
const _hoisted_18 = { class: "relative flex flex-row items-center gap-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "whitespace-nowrap" }, "Fecha de término", -1))
const _hoisted_20 = { class: "flex flex-col sm:flex-row sm:items-center gap-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-[16px]" }, "Excel", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "w-full overflow-auto" }
const _hoisted_25 = { class: "table-auto w-full border-spacing-y-1 border-separate text-left" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "items-center" }, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("p", { class: "flex text-[16px]" }, "Fecha")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("p", { class: "flex text-[16px] px-4" }, "Tipo movimiento")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("p", { class: "flex text-[16px] px-4" }, "Accionista asociado")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("p", { class: "flex text-[16px] px-6" }, "Acciones A")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("p", { class: "flex text-[16px] px-6" }, "Nº Total Acc. A")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("p", { class: "flex text-[16px] px-6" }, "Acciones B")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("p", { class: "flex text-[16px] px-6" }, "Nº Total Acc. B")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("p", { class: "flex text-[16px] px-6" }, "Contrato")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text-[16px] px-4" }, "Acciones")
  ])
], -1))
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "flex items-center" }, null, -1))
const _hoisted_29 = { class: "text-[16px]" }
const _hoisted_30 = { class: "py-2 px-4" }
const _hoisted_31 = { class: "flex text-[16px]" }
const _hoisted_32 = { class: "py-2 px-4" }
const _hoisted_33 = { class: "flex text-[16px]" }
const _hoisted_34 = { class: "py-2 px-4" }
const _hoisted_35 = { class: "flex text-[16px] justify-end" }
const _hoisted_36 = { class: "py-2 px-4" }
const _hoisted_37 = { class: "flex text-[16px] justify-end" }
const _hoisted_38 = { class: "py-2 px-4" }
const _hoisted_39 = { class: "flex text-[16px] justify-end" }
const _hoisted_40 = { class: "py-2 px-4" }
const _hoisted_41 = { class: "flex text-[16px] justify-end" }
const _hoisted_42 = { class: "py-2" }
const _hoisted_43 = { class: "flex w-full" }
const _hoisted_44 = { class: "py-2 px-4" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-full h-4"
}, null, -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = {
  key: 0,
  class: "w-full text-center"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No existen movimientos para este accionista", -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center my-7" }, [
  /*#__PURE__*/_createTextVNode(" Esta acción borrara definitivamente el movimiento. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ¿ Desea continuar con la acción ? ")
], -1))

import { onMounted, watch, computed, ref } from "vue";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import {
  contractOptions,
  ShareholderMovement,
} from "@/services/movements/types";
import { MovementService } from "@/services/movements/MovementService";

import { accountStore } from "@/stores/account";

import { User } from "@/services/auth/types";

import moment from "moment";
import Swal from "sweetalert2";

import { shareMovementStore } from "@/stores/movements";
import { useShareholderStore } from "@/stores/shareholder";

import NewModal from "../atoms/NewModal.vue";
import ContractButonGroup from "../molecules/contract/ContractButonGroup.vue";
import CreateContactModal from "../molecules/contract/CreateContactModal.vue";
import UploadContractModal from "../molecules/contract/UploadContractModal.vue";
import SignedContractModal from "@/components/molecules/contract/SignedContractModal .vue";
import NewMovementModal from "@/components/organisms/NewMovementModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareholderSharesTable',
  setup(__props) {

const shareholderStore = useShareholderStore();
const movementsStore = shareMovementStore();

const accountStr = accountStore();

const router = useRouter();
const showNewMovementModal = ref(false);
const showCreateContractModal = ref(false);
const isVisibleConfirmationModal = ref(false);
const showUploadContractModal = ref(false);
const showSignedContractModal = ref(false);

const { filter } = storeToRefs(movementsStore);

const idMovementSelected = ref<number>();
const shareholderId = computed(() =>
  Number(router.currentRoute.value.params.id)
);
const movementService = new MovementService();
const shareholder = computed(() => shareholderStore.shareholder);
const movements = computed(() => {
  let totalGroupAAmount = 0;
  let totalGroupBAmount = 0;

  if (!movementsStore.movements) return [];
  return [...movementsStore.movements]
    .sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
    .reverse() // Invierte el array para recorrerlo en orden inverso
    .map((movement) => {
      if (movement.buyerUserId == shareholderId.value) {
        totalGroupAAmount += movement.groupAAmount;
        totalGroupBAmount += movement.groupBAmount;
      } else {
        totalGroupAAmount -= movement.groupAAmount;
        totalGroupBAmount -= movement.groupBAmount;
      }

      movement.AFinalAmount = totalGroupAAmount;
      movement.BFinalAmount = totalGroupBAmount;

      return movement;
    })
    .reverse(); // Invierte el array de nuevo para restaurar el orden original
});

function documentSelectorHandler(
  contractOptionSelected: contractOptions,
  movementIdSelected: number
) {
  idMovementSelected.value = movementIdSelected;
  switch (contractOptionSelected) {
    case contractOptions.generate:
      showCreateContractModal.value = true;
      break;
    case contractOptions.upload:
      showUploadContractModal.value = true;
      break;
    case contractOptions.signed:
      showSignedContractModal.value = true;
      break;
    default:
      break;
  }
  return false;
}
function reload() {
  movementsStore.query(shareholderId.value);
}
function deleteHandler(movementId: number) {
  isVisibleConfirmationModal.value = !isVisibleConfirmationModal.value;
  idMovementSelected.value = movementId;
}
async function deleteMovement() {
  if (!idMovementSelected.value) return false;
  const response = await movementService.deleteMovement(
    idMovementSelected.value
  );
  if (!response.success) {
    Swal.fire(
      "¡Error!",
      "Algo salió mal, vuelva a recargar la página.",
      "error"
    );
  }
  Swal.fire("¡Listo!", "Movimiento eliminado con éxito", "success");
  isVisibleConfirmationModal.value = !isVisibleConfirmationModal.value;
  reload();
  movementsStore.query(shareholderId.value);
  shareholderStore.query(shareholderId.value);
}

function isBuyer(movement: ShareholderMovement) {
  return movement.buyerUserId == shareholder.value?.id;
}

function getAmountA(movement: ShareholderMovement) {
  if (isBuyer(movement)) return movement.groupAAmount ?? "0";
  return -movement.groupAAmount;
}

function getAmountB(movement: ShareholderMovement) {
  if (isBuyer(movement)) return movement.groupBAmount;
  return -movement.groupBAmount;
}

const getShareholderName = (sellerUser: User) => {
  if (
    sellerUser?.businessName != null &&
    sellerUser?.businessName?.trim() != ""
  ) {
    return sellerUser?.businessName;
  } else {
    return `${sellerUser?.firstName} ${sellerUser?.lastName}`;
  }
};

function getSellerShareholder(movement: ShareholderMovement) {
  if (movement?.groupAAmount) {
    if (movement?.sellerUser?.investorNumberA) {
      return `[ID-A ${
        movement.sellerUser?.investorNumberA
      }] ${getShareholderName(movement?.sellerUser)}`;
    }
  }
  if (movement?.sellerUser?.investorNumberB) {
    return `[ID-B ${movement.sellerUser?.investorNumberB}] ${getShareholderName(
      movement?.sellerUser
    )}`;
  }

  return "-";
}

function getBuyerShareholder(movement: ShareholderMovement) {
  console.log("aca no es");
  if (movement.groupAAmount) {
    if (movement?.buyerUser?.investorNumberA) {
      return `[ID-A ${
        movement.buyerUser?.investorNumberA
      }] ${getShareholderName(movement?.buyerUser)}`;
    }
  }

  if (movement?.buyerUser?.investorNumberB) {
    return `[ID-A ${movement.buyerUser?.investorNumberB}] ${getShareholderName(
      movement?.buyerUser
    )}`;
  }
  return "-";
}

// Export to excel ...

const downloadExcel = async () => {
  console.log(accountStr);
  await movementService.downloadExcel(shareholderId.value, filter.value);
};

// Filter stuff

watch(filter.value, () => {
  movementsStore.query(shareholderId.value);
});

onMounted(() => {
  movementsStore.query(shareholderId.value);
});

return (_ctx: any,_cache: any) => {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (shareholder.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("section", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(shareholder.value.totalSharesA ? shareholder.value.totalSharesA : 0), 1),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(shareholder.value?.investorNumberA
                    ? "Accionista:" + shareholder.value.investorNumberA.toString()
                    : "Sin información"), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("section", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(shareholder.value.totalSharesB ? shareholder.value.totalSharesB : 0), 1),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(shareholder.value && shareholder.value.investorNumberB
                    ? "Accionista:" + shareholder.value.investorNumberB?.toString()
                    : "Sin información"), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_Datepicker, {
                    modelValue: _unref(filter).start_date,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filter).start_date) = $event)),
                    "teleport-center": "",
                    "input-class-name": "newcalssinput",
                    "enable-time-picker": false,
                    format: "MM/yyyy",
                    cancelText: 'Cancelar',
                    selectText: 'Seleccionar'
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_Datepicker, {
                    modelValue: _unref(filter).end_date,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filter).end_date) = $event)),
                    "teleport-center": "",
                    "input-class-name": "newcalssinput",
                    "enable-time-picker": false,
                    "min-date": _unref(filter).start_date,
                    format: "MM/yyyy",
                    cancelText: 'Cancelar',
                    selectText: 'Seleccionar'
                  }, null, 8, ["modelValue", "min-date"])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "btn btn-excel h-[33px]",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (downloadExcel()))
                }, _hoisted_23),
                _createElementVNode("button", {
                  class: "btn h-[35px]",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (showNewMovementModal.value = true))
                }, " Crear movimiento ")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("table", _hoisted_25, [
          _hoisted_26,
          (movements.value && movements.value.length > 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_27, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(movements.value, (movement) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: movement.id,
                    class: "hover:bg-gray-100 cursor-pointer items-center"
                  }, [
                    _hoisted_28,
                    _createElementVNode("td", _hoisted_29, _toDisplayString(_unref(moment)(movement.createdAt).format("DD/MM/YYYY")), 1),
                    _createElementVNode("td", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, _toDisplayString(movement.buyerUserId == shareholderId.value ? "Compra" : "Venta"), 1)
                    ]),
                    _createElementVNode("td", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, _toDisplayString(movement.buyerUserId == shareholderId.value
                    ? movement.sellerUserId
                      ? getSellerShareholder(movement)
                      : "Rentas Dhelos"
                    : movement.buyerUserId
                    ? getBuyerShareholder(movement)
                    : "Rentas Dhelos"), 1)
                    ]),
                    _createElementVNode("td", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, _toDisplayString(getAmountA(movement) == 0 ? "-" : getAmountA(movement)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, _toDisplayString(movement.buyerGroupAFinalAmount), 1)
                    ]),
                    _createElementVNode("td", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, _toDisplayString(getAmountB(movement) == 0 ? "-" : getAmountB(movement)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, _toDisplayString(movement.buyerGroupBFinalAmount), 1)
                    ]),
                    _createElementVNode("td", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(ContractButonGroup, {
                          onButtonAction: documentSelectorHandler,
                          movementId: movement.id,
                          isContractSigned: movement.isContractSigned
                        }, null, 8, ["movementId", "isContractSigned"])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_44, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (deleteHandler(movement.id)),
                        class: "text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-1 text-center inline-flex items-center mr-2"
                      }, _hoisted_47, 8, _hoisted_45)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        (movements.value && movements.value.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_50))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(NewMovementModal, {
      visible: showNewMovementModal.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((showNewMovementModal).value = $event))
    }, null, 8, ["visible"]),
    (showCreateContractModal.value)
      ? (_openBlock(), _createBlock(CreateContactModal, {
          key: 0,
          visible: showCreateContractModal.value,
          "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((showCreateContractModal).value = $event)),
          "movement-id": idMovementSelected.value
        }, null, 8, ["visible", "movement-id"]))
      : _createCommentVNode("", true),
    (showUploadContractModal.value)
      ? (_openBlock(), _createBlock(UploadContractModal, {
          key: 1,
          visible: showUploadContractModal.value,
          "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((showUploadContractModal).value = $event)),
          "movement-id": idMovementSelected.value ? idMovementSelected.value : -1,
          onReload: reload
        }, null, 8, ["visible", "movement-id"]))
      : _createCommentVNode("", true),
    (showSignedContractModal.value)
      ? (_openBlock(), _createBlock(SignedContractModal, {
          key: 2,
          visible: showSignedContractModal.value,
          "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((showSignedContractModal).value = $event)),
          "movement-id": idMovementSelected.value ? idMovementSelected.value : -1
        }, null, 8, ["visible", "movement-id"]))
      : _createCommentVNode("", true),
    _createVNode(NewModal, {
      title: "Confirmación",
      visible: isVisibleConfirmationModal.value,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (isVisibleConfirmationModal.value = !isVisibleConfirmationModal.value))
    }, {
      default: _withCtx(() => [
        _hoisted_51
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          class: "bg-button-green shadow-md text-white",
          onClick: deleteMovement
        }, " Aceptar ")
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})